import { render, staticRenderFns } from "./CClassifiedSellerCardTelephone.vue?vue&type=template&id=5c1adc7c&scoped=true&"
import script from "./CClassifiedSellerCardTelephone.vue?vue&type=script&lang=ts&"
export * from "./CClassifiedSellerCardTelephone.vue?vue&type=script&lang=ts&"
import style0 from "./CClassifiedSellerCardTelephone.vue?vue&type=style&index=0&id=5c1adc7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1adc7c",
  null
  
)

export default component.exports